import { useTranslation } from "react-i18next";

export default function Testimonial() {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col lg:flex-row bg-white">
      <div className="flex-1 flex items-center p-8 md:p-14 lg:p-20">
        <div className="max-w-xl">
          <div className="flex items-center gap-2 mb-8">
            <div className="w-2 h-2 rounded-full bg-foreground-900"></div>
            <span className="text-xs font-semibold text-foreground-500 uppercase tracking-widest">
              {t("testimonial_label")}
            </span>
          </div>

          <blockquote className="text-xl md:text-2xl lg:text-3xl font-heading font-medium italic text-foreground-900 leading-relaxed">
            <span className="text-4xl md:text-5xl text-primary-400 font-heading leading-none">&ldquo;</span>
            {t("testimonial_quote")}
          </blockquote>

          <div className="mt-8 flex items-center gap-4">
            <div>
              <p className="text-sm font-semibold text-foreground-900">
                {t("testimonial_name")}
              </p>
              <div className="flex items-center gap-2 mt-1">
                <div className="flex items-center gap-0.5">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-accent-400 text-xs w-3 h-3 flex items-center justify-center"></i>
                  ))}
                </div>
                <span className="text-xs text-foreground-500">
                  {t("testimonial_platform")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-1 min-h-[400px] lg:min-h-[600px] relative overflow-hidden bg-background-100">
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20fashion%20portrait%20of%20stylish%20young%20European%20man%20in%20cream%20knit%20sweater%20and%20dark%20trousers%20looking%20up%20confidently%20against%20warm%20oatmeal%20colored%20studio%20backdrop%20soft%20natural%20daylight%20from%20large%20window%20minimalist%20editorial%20fashion%20photography%20high%20quality%20artistic%20composition%20gentle%20expression%20elegant%20atmosphere&width=700&height=900&seq=testimonial-portrait-v3&orientation=portrait"
          alt={t("testimonial_name")}
          title={t("testimonial_name") + " – zadowolony klient Kakobuy Spreadsheet"}
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
      </div>
    </section>
  );
}